import { render, staticRenderFns } from "./orderWeeklyDetailItemPrint.vue?vue&type=template&id=bff5a9a6&scoped=true&"
import script from "./orderWeeklyDetailItemPrint.vue?vue&type=script&lang=js&"
export * from "./orderWeeklyDetailItemPrint.vue?vue&type=script&lang=js&"
import style0 from "./orderWeeklyDetailItemPrint.vue?vue&type=style&index=0&id=bff5a9a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff5a9a6",
  null
  
)

export default component.exports